import { useLayoutEffect } from "react"
import { useAuth } from "@clerk/clerk-react"
import { setClerkTokenGetter } from "../utils/clerk-token-provider"

export function useClerkAuth() {
  const { getToken } = useAuth()

  // Install before descendant React Query subscriptions start protected requests.
  useLayoutEffect(() => {
    setClerkTokenGetter(getToken)
  }, [getToken])
}
